import UIPopover from "./popover_controller";
import { useTransition } from "stimulus-use";

export default class extends UIPopover {
  connect() {
    useTransition(this);
  }
}
